import React, {useEffect} from 'react';
import Header from '../components/Header';
import { useParams } from "react-router-dom";
import TabSwitcher from '../../Units/TabSwitcher';
import SelectDownline from './components/SelectDownline';
import GrantCredit from './components/GrantCredit';
import Members from '../Members/components/Members';
import { CurrentDownline } from './components';

const tabs = [{name: 'selectDownline', view: SelectDownline},
    {name: 'grantCredit', view: GrantCredit}, 
    {name: 'currentDownline', view: CurrentDownline}];

const AgentMenu = () => {
    const { memberId: memberId } = useParams();
    const { id: clubId } = useParams();

    return (
        <div className={`agentMenu`}>
            <Header title={'agentMenu'} to={`/club/${clubId}/members/${memberId}`}/>
            <TabSwitcher tabs={tabs} defaultSelected={2}/>
        </div>
    );
};

export default AgentMenu ;
